module.exports = __webpack_public_path__ + "static/media/cerateBlue.1a4e0d5e.svg";